export default {
  Seo: {
    title: 'Bundle',
    description:
      'Bundle is the simple way to compare mortgage rates. Learn the basics of a mortgage loan, create a budget using our mortgage calculator, and receive real mortgage rate quotes, anonymously.',
  },
  Calculators: {
    title: 'How much home can I afford | Simple Calculator | Bundle',
    description: 'Mortgage Calculator',
  },
  AboutUs: {
    title: 'About Us | Bundle',
  },
  Faqs: {
    title: 'Faq | Bundle',
  },
  TodaysRates: {
    title: "Today's Mortgage Rates | Bundle",
  },
  PrivacyPage: {
    title: 'Privacy Policy | Bundle',
  },
  TermsPage: {
    title: 'Terms & Conditions | Bundle',
  },
  RealEstateAgentDashboard: {
    title: 'Dashboard | Bundle',
    description: '',
  },
  RealEstateAgentLoanOfficers: {
    title: 'Add favorite Loan Officers | Bundle',
    description: '',
  },
  RealEstateAgentSettingsPage: {
    title: 'Settings | Bundle',
    description: 'Account Settings',
  },
  LoanOfficerDashboard: {
    title: 'Dashboard | Bundle',
  },
  LoanOfficerMessages: {
    title: 'Connections | Bundle',
  },
  BuyerMessages: {
    title: 'Messages | Bundle',
  },
  NonAuthSurveyPage: {
    title: 'Mortgage Rates | Personalized For You | Bundle',
  },
  LoanOfficerSettings: {
    title: 'Settings | Bundle',
    description: 'Account Settings',
  },
  SurveyPage: {
    title: 'Mortgage Rates | Personalized For You | Bundle',
  },
  LoanOfficerSearchSurvey: {
    title: 'Mortgage Rates | Personalized For You | Bundle',
  },
  NonAuthHomePage: {
    title: 'Bundle: A Modern Mortgage Company',
  },
  QuizPage: {
    title: 'Home Price Budget | Bundle',
    description:
      'Complete your personalized home budget in a few minutes. Easily determine your home price and down payment based on your income and savings.',
  },
  BuyerSettings: {
    title: 'Settings | Bundle',
    description: 'Account Settings',
  },
  ReferralRealEstateAgent: {
    title: 'Referral Real Estate Agent | Bundle',
    description: "Compare your agent's favorite mortgage loan officers",
  },
  LoanOfficerRealEstateAgent: {
    title: 'Find Real Estate Agent | Bundle',
    description: '',
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en/meta.js